import { RequestSender } from "./helpers";
import { EmailLoginResponse } from "./model";

type AuthClassWalletSessionInput = {
  readonly orderId: string;
  readonly password: string;
  readonly userAuthType: "sign-up" | "sign-in";
};

async function authClassWalletSession(
  request: RequestSender,
  { orderId, userAuthType, password }: AuthClassWalletSessionInput,
): Promise<EmailLoginResponse> {
  const response = await request<any>(
    "put",
    `/class-wallet/order-sessions/${encodeURIComponent(orderId)}/auth`,
    {
      userAuthType,
      password,
    },
  );
  if (response.status !== 200) {
    throw new Error(
      response.data.message ?? "Error trying to add auth to class wallet",
    );
  }
  const {
    data: { data },
  } = response;

  return {
    id: data.id,
    username: data.sUserName,
    emailAddress: data.sEmail,
    userType: data.eUserType,
    loginType: {
      type: data.oLoginType.eType,
    },
    authToken: response.headers.authorization,
    bIsSubscribed: data.bIsSubscribed,
    aCurrentAccess: data.aCurrentAccess,
  };
}

export type { AuthClassWalletSessionInput };
export default authClassWalletSession;
